<template>
  <div class="wrapper">
    <img v-if="downloadBanner != ''" :src="downloadBanner" class="backgroundImg">
    <img v-if="downloadBanner == ''" src="../assets/img/download_b.jpg" class="backgroundImg">
    <div class="img-box" style="z-index: 1000;">
      <div id="downloadQrCode"></div>
      <p class="img-box-title">苹果 + 安卓端下载</p>
    </div>

  </div>
</template>

<script>
  import QRCode from 'qrcodejs2'
    export default {
      name: "download",
      data(){
        return {
          info:{
            qq:[],
            phone:[],
            codes:[]
          },
          downloadBanner: ""
        }
      },
      computed:{
      },
      methods:{
        QrCode(url) {
          new QRCode('downloadQrCode', {
            width: 345,
            height: 345,
            text: url, // 二维码地址
          })
        },
        getInfoData() {
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "web_common"
              }
            })
            .then(function(res) {
              if (res.data.code == 1) {
                var data = res.data.data;
                that.info = data;
                that.QrCode(that.info.codes[0].code);
                that.downloadBanner = res.data.data.downgrade_image;
              } else if (res.data.code == 0) {
                that.$message.error(res.data.msg);
              }
            });
        }
      },
      mounted:function () {
        this.getInfoData();
      }
    }
</script>

<style scoped>
.wrapper {
  /* background: url(../assets/img/bg.png) no-repeat center; */
  /* background-size: cover;
  background-position: 5% 70%; */
  min-width: 1000px;
  height: 720px;
  overflow: hidden;
  position: relative;
}

.backgroundImg{
  pointer-events: none;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
}
  .img-box{
    width: 400px;
    opacity: 0.85;
    /*padding: 20px;*/
    background: white;
    margin: 200px auto;
    padding-top: 20px;
  }
  .img-box-title{
    text-align: center;
    font-size: 25px;
    padding: 10px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/download.vue